import React from 'react';

export const InProcess = () => {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_4134_2802)">
                <path
                    d="M7 14C3.14008 14 0 10.8599 0 7C0 3.14008 3.14008 0 7 0C10.8599 0 14 3.14008 14 7C14 10.8599 10.8599 14 7 14ZM7 1.16667C3.7835 1.16667 1.16667 3.7835 1.16667 7C1.16667 10.2165 3.7835 12.8333 7 12.8333C10.2165 12.8333 12.8333 10.2165 12.8333 7C12.8333 3.7835 10.2165 1.16667 7 1.16667Z"
                    fill="white"
                />
                <path
                    d="M7 2C7.84598 2 8.67812 2.21465 9.41855 2.62386C10.159 3.03307 10.7835 3.62345 11.2336 4.33975C11.6837 5.05605 11.9447 5.87485 11.9921 6.71949C12.0396 7.56414 11.872 8.40702 11.5049 9.16923C11.1379 9.93145 10.5835 10.5881 9.89357 11.0777C9.20365 11.5672 8.40078 11.8738 7.56013 11.9685C6.71948 12.0633 5.86852 11.9432 5.08692 11.6195C4.30531 11.2959 3.61861 10.7791 3.0911 10.1178L7 7L7 2Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_4134_2802">
                    <rect width="14" height="14" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
